let template = `<div class="alert alert-dismissible alert-{{type}}">
    <button type="button" class="close"> 
      <span aria-hidden="true">&times;</span>
    </button>
    <span class="glyphicon {{icon_class}} pull-left"></span>
    <div class="message ">
      {{message}}
      {{#if link_url}}
        {{#if link_title}}
          &nbsp;<a href="{{link_url}}" target="_blank">{{link_title}}</a>
        {{/if}}
      {{/if}}
    </div>

</div>`;

/*
 * Marionette ItemView: AlertView
 * -------------------------------
 * Shows success/error alerts, scheduled maintance items and server outage incidents
 */
import _ from 'underscore';
import Handlebars from 'handlebars';
import Marionette from 'backbone.marionette';

    var LEGAL_MESSAGE_TYPES = ['danger', 'warning', 'success', 'info'];
    var ICON_CLASSES = {
        danger: 'glyphicon-remove-sign',
        warning: 'glyphicon-warning-sign',
        success: 'glyphicon-ok-sign',
        info: 'glyphicon-info-sign'
    };
    var AlertView = Marionette.View.extend({

        /* Basic Properties */
        template: Handlebars.compile(template),

        /* Events
         * ------
         * Responsible for hiding the alert when the close button is clicked
         */
        events: {
            'click button.close': 'close'
        },

        ui: {
          alert: '.alert'
        },

        closeTimer: null,

        clearCloseTimer: function() {
            if (this.closeTimer) {
                clearTimeout(this.closeTimer);
                this.closeTimer = null;
            }
        },

        serializeData: function() {
            var type = this.getMessageType();
            var message = this.options.message;
            var link_url = this.options.link_url;
            var link_title = this.options.link_title;
            var header = this.options.header;

            if (this.model){
                header = header || this.model.get('header');
                type = type || this.model.get('type');
                message = message || this.model.get('message');
                link_url = link_url || this.model.get('link_url');
                link_title = link_title || this.model.get('link_title');
            }

            return {
                header: header || false,
                type: type,
                message: message,
                icon_class: ICON_CLASSES[type],
                link_url: link_url || false,
                link_title: link_title || false
            };
        },
        getMessageType: function() {
            var type = this.options.messageType || this.model.get('type');
            if (LEGAL_MESSAGE_TYPES.indexOf(type) == -1) {
                console.warn("Invalid message type", type);
                type = LEGAL_MESSAGE_TYPES[0];
            }
            return type;
        },
        onAttach: function() {
            var self = this;

            // Display the alert
            this.ui.alert.fadeIn(200);

            var timeout = this.options.timeout;
            if (this.model){
                timeout =  timeout || this.model.get('timeout');
            }

            // Close the alert automatically
            if (timeout !== 0) {
                // Set default timeout
                if (!this.options.timeout) {
                    if (this.getMessageType() === 'danger') {
                        timeout = 5000;
                    } else {
                        timeout = 3000;
                    }
                }
                this.closeTimer = setTimeout(function() { self.close(); }, timeout);
            }
        },

        onDestroy: function() {
            // Cancel fade-out timer to avoid prematurely closing any new alerts
            this.clearCloseTimer();
        },

        close: function() {
            this.clearCloseTimer();
            this.ui.alert.fadeOut(200, _.bind(this.destroy, this));
        }
    });

    export default AlertView;

